// Riding art on demand (bike plan 3, task 4): the atlases from scripts/anim/bike/export.py load the way the walk
// sheets do, outside the manifest (its image loader reads no atlas JSON, and the 1 MB tier-0 cap stays untouched).
// bikeArtKeys.mjs says which keys a scene needs.
import Phaser from 'phaser';
import { assetUrl } from '../assetVersion.js';
import { bikeArtToRelease } from './bikeArtKeys.mjs';

// Load the atlases this scene does not have yet, then call back. A key that fails is left missing (the layouts skip
// what `has` says is not there). Safe to call while the scene's loader is busy.
export function ensureBikeArt(scene, keys, cb) {
  const missing = keys.filter((k) => !scene.textures.exists(k));
  if (!missing.length) { cb(); return; }
  const pending = new Set(missing);
  const settle = (k) => {
    if (!pending.delete(k)) return;
    if (pending.size === 0) { scene.load.off(Phaser.Loader.Events.FILE_LOAD_ERROR, onError); cb(); }
  };
  // One shared error listener: `once` per key would be consumed by whichever file fails first.
  const onError = (file) => { if (pending.has(file.key)) { console.warn('[bikeArt] missing atlas', file.key); settle(file.key); } };
  scene.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, onError);
  for (const k of missing) {
    scene.load.atlas(k, assetUrl(`/assets/bike/${k}.webp`), assetUrl(`/assets/bike/${k}.json`));
    scene.load.once(`${Phaser.Loader.Events.FILE_COMPLETE}atlasjson-${k}`, () => settle(k));
  }
  // A file that downloaded but failed to decode reports through a different path; when the loader is done,
  // whatever is still pending is missing for good.
  scene.load.once(Phaser.Loader.Events.COMPLETE, () => { for (const k of [...pending]) settle(k); });
  if (!scene.load.isLoading()) scene.load.start();
}

// Drop the riders, clothes and designs the next scene does not need (keep: the local rider and the peers present).
export function releaseBikeArt(scene, keep) {
  const rig = scene.cache.json.get('bike_rig');
  if (!rig) return;
  for (const k of bikeArtToRelease(scene.textures.getTextureKeys(), keep, rig)) scene.textures.remove(k);
}
